module.exports = __webpack_public_path__ + "static/media/logo.a3aaa7c4.svg";